import React from 'react'

const Svg = (props) => {
  const location = props.location || window.location.href
  const xlinkHref = `${location}#${props.iconName}`

  return (
    <svg className={props.className || `icon ${props.iconName}`}>
      <use xlinkHref={xlinkHref}></use>
    </svg>
  )
}

export default Svg
